/* Keyword-to-page map (SEO round 2026-10-26). Source: Keywords.xlsx. Used by seoExtras.ts and the audit script. */
export const SEO_KEYWORDS_BY_PATH: Record<string, string[]> = {
  "/grading-scale/18-questions/": [
    "18 question test grading scale",
    "if there are 18 questions how much is each worth",
    "18 question grading scale",
    "if there is 18 questions how many points each",
    "grade scale for 18 questions",
    "15 out of 18 score",
    "if there are 18 questions",
    "12 18 score",
    "16 out of 18 score"
  ],
  "/grading-scale/15-questions/": [
    "15 question grading scale",
    "if a test has 15 questions how much is each question worth",
    "how much is each question worth on a 15 question test",
    "if you have 15 questions how much is each worth",
    "on a 15 question test how many points each",
    "15 questions how many points each",
    "how many points is each question worth on a 15 question test",
    "15 questions grading scale",
    "how many points is each question on a 15 question test",
    "grading for 15 questions",
    "what is a 12/15 grade",
    "what grade is 10/15",
    "what is a 10/15 grade",
    "8/15 grade",
    "grading scale for 15 question test",
    "15 question quiz grading scale",
    "15 question test how many points each",
    "grades for 15 questions",
    "how many points is each question if there are 15 questions",
    "6/15 grade",
    "what is a 8 out of 15",
    "15 questions 1 wrong percentage",
    "grade out of 15"
  ],
  "/grading-scale/40-questions/": [
    "40 questions one score"
  ],
  "/grading-scale/16-questions/": [
    "16 question test grading scale",
    "16 questions grading scale",
    "if there are 16 questions on a test",
    "16 question grading scale",
    "grading scale for 16 questions",
    "3 wrong out of 16",
    "grade scale for 16 questions",
    "if you have 16 questions how many points each",
    "grading scale for 16 question test",
    "grading scale 16 questions",
    "if a test has 16 questions how many points is each question worth",
    "2 wrong out of 16",
    "if there are 16 questions on a test how much is each question worth",
    "if there are 16 questions on a test and you miss 3",
    "if there is 16 questions",
    "16 questions how many points each",
    "16 questions 2 wrong",
    "16 wrong",
    "6 wrong out of 16",
    "10/16 score",
    "14 16 test grade",
    "what is a 13/16 grade",
    "what is a 11/16 grade",
    "what score is a 14/16",
    "1 wrong out of 16",
    "12/16 grade",
    "9.5 out of 16",
    "12/16 score"
  ],
  "/": [
    "easy grade calculator",
    "ez grader",
    "easy grader",
    "ezgrader",
    "ez grader online",
    "online ez grader",
    "grading",
    "easy grader calculator",
    "easy grader online",
    "easygradecalculator",
    "quickgrade calculator",
    "easy grader free online",
    "free grading calculator",
    "ez grade calculator",
    "quickgrade",
    "online easy grader free",
    "quick grader",
    "ezgrade",
    "easy grades calculator",
    "ezgrader online",
    "online easy grader",
    "quick grade",
    "online grader calculator",
    "free easy grader online",
    "grader tool",
    "easy grading calculator",
    "easy grader for teachers",
    "online grading calculator",
    "easygrade",
    "ez grader calculator",
    "free ez grader",
    "grade checker",
    "teacher grading tool",
    "ez grader free",
    "easy quick grader",
    "free easy grader",
    "calculator for grading",
    "grading tool",
    "grades calculator",
    "online grader",
    "easy grades",
    "easy grade",
    "free grader",
    "teacher percentage calculator",
    "grade calculator ez grader",
    "easy online grader",
    "grade calculator easy",
    "easy grade calculator with half points",
    "ez grader online free",
    "online ezgrader",
    "easy grader online free",
    "grading tool for teachers",
    "grade calculator for teachers",
    "quick grading",
    "teacher easy grader",
    "teacher grading calculator",
    "teacher grade calculator",
    "grading calculator for teachers",
    "grading helper",
    "teacher calculator for grades",
    "grading calculator free",
    "easygrader",
    "ez grade",
    "teachers grading calculator"
  ],
  "/grading-scale/": [
    "grading scale",
    "grading scales",
    "grade scale",
    "grade chart",
    "grading scale chart",
    "teacher grader scale",
    "online grading scale",
    "8 question grading scale",
    "grading scale for teachers",
    "score scale",
    "grade table",
    "teacher grading scale",
    "grading chart",
    "20 point grading scale",
    "grading scale 20 points",
    "grade list with percentage",
    "easy grader chart",
    "ez grader chart",
    "percentage chart for grades",
    "grading scale online",
    "grading score chart",
    "grading percentage chart",
    "grading chart for students",
    "ez grader scale",
    "percentage wise grade chart",
    "grade percentage chart",
    "ez grader slide chart",
    "grading scale for 50 marks",
    "grading scale calculator"
  ],
  "/final-exam-grade-calculator/": [
    "exam score calculator",
    "final exam calculator",
    "test calculator final",
    "final exam test calculator",
    "final test calculator",
    "online final exam calculator",
    "final grade calculator",
    "final grade calculator weighted",
    "exam calculator percentage",
    "final test grade calculator",
    "exam grade calculator",
    "finals score calculator",
    "finals exam calculator",
    "grade calculator final exam",
    "calculate final exam",
    "final grade calculator with exam",
    "what do i need to get on my final",
    "exam calculator",
    "final exam score",
    "calculate final score",
    "grading calculator final",
    "if my final is worth 20 percent",
    "exam grade",
    "if i have a 95 in a class and fail the final",
    "what is my grade after final",
    "exam mark calculator",
    "exam pass calculator",
    "minimum grade to pass",
    "calculate grade needed to pass",
    "calculate my final",
    "what did i get on my final",
    "calculate my final exam",
    "calculate final mark",
    "what do i need on my final to pass",
    "final calculator exam",
    "final percentage",
    "what can i get on my final",
    "what do i have to make on my final",
    "final exam calculation",
    "final test score calculator",
    "final exam percentage calculator",
    "final score calculator",
    "final exam calculator grade",
    "weighted exam calculator",
    "how much are final exams worth",
    "exam final grade calculator",
    "test final calculator"
  ],
  "/grade-calculator/": [
    "weighted grade calculator",
    "grade calculator",
    "grade calculator weighted average",
    "weight grades",
    "weighted mark calculator",
    "weighted average calculator grades",
    "weighted average for grades",
    "how to work out grade",
    "weightage marks calculator",
    "calculate weighted grade",
    "calculate grade",
    "calculator for weighted grades",
    "weighted test calculator",
    "online grade calculator",
    "weighted score calculation",
    "calculator with weighted grades"
  ],
  "/grading-scale/35-questions/": [
    "if there are 35 questions on a test how many can i miss",
    "35 question grading scale",
    "if a test has 35 questions how much is each question worth",
    "35 question test grading scale",
    "35 questions grading scale",
    "if you have 35 questions on a test",
    "if there are 35 questions on a test how much is each worth",
    "6 wrong out of 35",
    "35 question test",
    "if there are 35 questions on a test",
    "what grade is 29/35",
    "17/35 grade",
    "32/35 grade",
    "what grade is 30/35",
    "what is a 25/35 grade",
    "35 question test how many points each",
    "35 questions how many points each",
    "what grade is a 32 out of 35",
    "what is a 30/35 grade"
  ],
  "/average-grade-calculator/": [
    "grade average calculator",
    "average grade calculator",
    "average grade",
    "average score calculator",
    "letter grade average calculator",
    "grades calculator average",
    "median grade",
    "how to calculate your average grade",
    "calculate grade average",
    "average mark calculator",
    "test average calculator",
    "average test scores calculator",
    "average calculator grades",
    "grade average",
    "how to get the average of your grades",
    "how do you find out your average for grades",
    "averaging grades",
    "how to calculate average grade",
    "average of grades calculator",
    "what is the average of 79 and 100",
    "how to calculate average grade percentage",
    "class average calculator",
    "95 100 average",
    "average test grade calculator",
    "averaging grades calculator",
    "class average",
    "grade average calculator letter"
  ],
  "/tip-calculator/": [
    "gratuity calculator",
    "gratuity in math",
    "gratuity math",
    "tax gratuity calculator",
    "tip calculator america"
  ],
  "/grading-scale/60-questions/": [
    "if there are 60 questions on a test how much is each question worth",
    "60 questions how many can i get wrong",
    "out of 60 questions how many can i miss",
    "if a test has 60 questions how much is each question worth",
    "if a test is 60 questions how many points is each question",
    "what is a 46/60",
    "what grade is 44/60",
    "80% of 60 questions",
    "grading scale for 60 questions",
    "what is the passing score of 60"
  ],
  "/grading-scale/25-questions/": [
    "how many questions can i get wrong on a 25 question test",
    "how much is each question worth on a 25 question test",
    "how many questions can you get wrong on a 25 question test",
    "out of 25 questions how many can you miss to get a 70",
    "if there are 25 questions how much is each question worth",
    "if a test has 25 questions how much is each question worth",
    "how many questions can i miss on a 25 question test to get an 80",
    "on a 25 question test how many can i miss to get 80",
    "on a 25 question test how many can i miss to get 70",
    "25 question grading scale",
    "25 question test grading scale",
    "grading scale 25 questions",
    "whats a 17/25 grade",
    "how many questions can you miss on a 25 question test to get 80",
    "25 questions how many points each",
    "if there are 25 questions on a test and you miss 3"
  ],
  "/grading-scale/12-questions/": [
    "12 question test grading scale",
    "on a 12 question test how many points each",
    "2 wrong out of 12",
    "how much is each question worth on a 12 question test",
    "if there are 12 questions on a test how much is each question worth",
    "12 questions how many points each",
    "if there are 12 questions on a test how much is each worth",
    "what is 2 wrong out of 12",
    "grade calculator 12 questions",
    "what is an 8 out of 12"
  ],
  "/grading-scale/30-questions/": [
    "if a test has 30 questions how much is each question worth",
    "30 question test grading scale",
    "grading scale for 30 questions",
    "if there are 30 questions on a test how much is each question worth",
    "5 wrong out of 30",
    "how much is each question worth on a 30 question test",
    "if there are 30 questions on a test and you miss 3",
    "22/30 score",
    "what grade is 17 out of 30"
  ],
  "/grading-scale/20-questions/": [
    "how much is each question worth on a 20 question test",
    "15/20 grade",
    "what is a 19/20 grade",
    "what is the passing score of 20 items",
    "20 question grading scale",
    "what grade is 12/20",
    "what is a 11/20 grade",
    "what is a 16/20 on a test",
    "12/20 grade",
    "16/20 test score",
    "is 14 out of 20 bad",
    "18 out of 20 points",
    "what score is 15/20",
    "17/20 score",
    "11 out of 20 grade"
  ],
  "/gpa-calculator/": [
    "calculate gpa",
    "how to calculate your gpa",
    "how to calculate my gpa",
    "calculate a gpa",
    "gpa calculator with grades",
    "gpa compute",
    "average gpa calculator",
    "gpa meter",
    "score gpa calculator",
    "grade calculator 4.0 scale",
    "how to calculate your gpa on a 4.0 scale",
    "calculate my gpa",
    "how i calculate my gpa"
  ],
  "/grading-scale/75-questions/": [
    "75 question test how many can i miss",
    "75 questions how many can i get wrong",
    "how many questions can i miss on a 75 question test",
    "75 question test grading scale",
    "75 questions how many can i miss to get a 70",
    "65/75 grade"
  ],
  "/cgpa-to-percentage-calculator/": [
    "7.5 cgpa in percentage",
    "5.2 cgpa in percentage",
    "srm cgpa calculator",
    "how to convert cgpa into percentage out of 4",
    "5.75 cgpa to percentage",
    "64.8 percentage in cgpa",
    "convert cgpa to percentage on 10 point scale",
    "qpa to gpa calculator",
    "cgpa 5.2 to percentage",
    "cgpa 5.4 to percentage"
  ],
  "/semester-gpa-calculator/": [
    "projected gpa calculator",
    "predict gpa",
    "if i get a 4.0 this semester what will my gpa be",
    "calculating semester gpa"
  ],
  "/college-gpa-calculator/": [
    "how to calculate college gpa",
    "collegiate gpa calculator",
    "college board gpa calculator",
    "college grade calculator gpa"
  ],
  "/password-generator/": [
    "create random password",
    "easy random password generator",
    "generate a password online",
    "random password maker",
    "random password generate"
  ],
  "/test-grade-calculator/": [
    "what grade is a 20 out of 28",
    "51 question",
    "paper grading calculator",
    "79.50 .75",
    "42.75/45",
    "74 plus 80",
    "if i got 12 out of 14 what is my grade",
    "what is my grade if i got 11 out of 14",
    "8.33/12",
    "8 questions wrong out of 50",
    "if you miss 3 questions out of 16 what is your grade",
    "32.25/35",
    "50.5/60",
    "6 questions wrong out of 30",
    "paper grader calculator",
    "test grade calculator",
    "160/200 grade",
    "grade questions",
    "missed 7 questions out of 50",
    "good score calculator",
    "31.5/35",
    "if there is 14 questions on a test",
    "questions wrong calculator",
    "grade after test calculator",
    "quiz grade calculator"
  ],
  "/grading-scale/45-questions/": [
    "if there are 45 questions on a test",
    "45 questions grading scale",
    "what grade is a 37/45",
    "45 question test grading scale",
    "if there are 45 questions on a test how much is each question worth",
    "45 questions how many points each",
    "40/45 grade",
    "if there are 45 questions on a test how many can i miss to get a 80"
  ],
  "/loan-calculator/": [
    "provisional loan quote"
  ],
  "/cumulative-gpa-calculator/": [
    "calculate cumulative gpa",
    "overall gpa calculator",
    "how to figure your cumulative gpa",
    "calculate your cumulative gpa",
    "how to determine cumulative gpa",
    "how do you calculate your cumulative gpa"
  ],
  "/letter-grade-calculator/": [
    "what grade is 75 percent",
    "what is a 75 in grades",
    "60 score",
    "is 80 a good grade",
    "60 letter grade",
    "sample grade",
    "80 as a letter grade",
    "what grade is a 60"
  ],
  "/grading-scale/50-questions/": [
    "how many questions can you miss on a 50 question test to get 70",
    "45/50 grade",
    "10 wrong out of 50 questions",
    "50 question exam",
    "50 question exam percentage",
    "if a test has 50 questions how much is each question worth",
    "5 wrong out of 50 questions",
    "50 questions how many can i get wrong",
    "how many questions can i miss on a 50 question test to get an 80",
    "37/50 grade",
    "how many questions can i get wrong on a 50 question test to get an 80",
    "80 on a 50 question test",
    "13 wrong out of 50 grade"
  ],
  "/grade-curve-calculator/": [
    "ranked curve calculator grading",
    "grade curve calculator using average",
    "class curve calculator",
    "grading scale curve calculator",
    "curve grade calculator"
  ],
  "/grading-scale/100-questions/": [
    "what grade is a 75 out of 100",
    "how many questions can you miss on a 100 question test to get 70",
    "is 94 out of 100 good",
    "what is a 60/100"
  ],
  "/grading-scale/80-questions/": [
    "80 questions",
    "if there are 80 questions on a test how much is each question worth",
    "if there are 80 questions on a test",
    "80 question test grading scale",
    "is 45 out of 80 good marks"
  ],
  "/high-school-gpa-calculator/": [
    "gpa calculator school",
    "gpa class calculator"
  ],
  "/grading-scale/10-questions/": [
    "7.5 out of 10 grade",
    "what is a 6/10 grade"
  ],
  "/gpa-to-letter-grade/": [
    "what gpa is a 73",
    "4a 3b gpa",
    "gpa quality points chart",
    "gpa to grades calculator",
    "what would your gpa be with all b's"
  ],
  "/percentage-calculator/": [
    "grading percentage calculator"
  ]
};
